import { defineComponent as _defineComponent } from 'vue'
import type { NewTitleSpotlightModuleFragment } from '@/features/onboarded-home/types';

import BasicTitleCardFullImage from '@/components/list/title-card/BasicTitleCardFullImage.vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import SpotlightCardCornerTag from '@/features/onboarded-home/components/modules/spotlights/SpotlightCardCornerTag.vue';
import TitleScoreList from '@/components/TitleScoreList.vue';
import WatchNowButtonNew from '@/components/buttons/WatchNowButtonNew.vue';
import { faThumbsUp, faBookmark } from '@fortawesome/free-solid-svg-icons';

import { formatRuntime } from '@/helpers/title-helper';
import { SCORINGS, ScoringProvider } from '@/helpers/scoring-helper';

import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';
import { useI18n } from '@/helpers/composables/useI18n';
import { useHomeModuleTracking } from '@/features/onboarded-home/tracking';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewTitleSpotlightModule',
  props: {
    moduleData: null,
    globalPosition: null,
    localPosition: null
  },
  setup(__props: any) {

const props = __props as {
	moduleData: NewTitleSpotlightModuleFragment;
	globalPosition: number;
	localPosition?: number;
};



const { t } = useI18n();

const title = computed(() => props.moduleData.titles[0]);

const imdbIcon = SCORINGS.find(score => score.provider === ScoringProvider.IMDB)?.image;
const backgroundShadow =
	'linear-gradient(90deg, rgba(16, 22, 29, 0.68) 0%, rgba(16, 22, 29, 0) 100%), linear-gradient(0deg, rgba(16, 22, 29, 0.6), rgba(16, 22, 29, 0.6))';

const actionIcon = {
	HMSpotlightNewOnYourWatchlist: faBookmark,
	HMSpotlightNewSimilarToLikedTitle: faThumbsUp,
	HMSpotlightNewWithHighRatings: null,
};

const titleName = computed(() => {
	if (title.value.__typename === 'Season') {
		return title.value.show.content.title;
	}

	return title.value.content.title ?? '';
});

const stats = computed(() => {
	const stats = `${title.value.content.originalReleaseYear}`;

	if (title.value.content.runtime == null) return stats;

	const { translationKey, hours, minutes } = formatRuntime(title.value.content.runtime);

	if (isNaN(hours)) return stats;

	return `${stats} &#183; ${t(translationKey, { hours, minutes })}`;
});

/* TRACKING */
const { moduleContext, moduleObserveVisibility, trackHomeModule } = useHomeModuleTracking({
	moduleData: () => props.moduleData,
	globalPosition: () => props.globalPosition,
	localPosition: () => props.localPosition,
	objectId: () => props.moduleData.titles[0].id,
});

function trackTitleClicked(...contextData: Parameters<typeof SnowplowTitleContextGraphql.fromTitle>) {
	trackHomeModule('titleClicked', {
		spec: { label: moduleContext.value.type },
		contexts: [SnowplowTitleContextGraphql.fromTitle(...contextData)],
	});
}

return { __sfc: true,props, t, title, imdbIcon, backgroundShadow, actionIcon, titleName, stats, moduleContext, moduleObserveVisibility, trackHomeModule, trackTitleClicked, BasicTitleCardFullImage, PictureComp, SpotlightCardCornerTag, TitleScoreList, WatchNowButtonNew }
}

})